import permissions from '../permissions'

const TASK_LIST = [
  {
    name: 'Listar Todas',
    tag: permissions.KANBAN_TASKS.LIST,
    exclusiveWith: permissions.KANBAN_TASKS.LIST_BY_DEPARTMENT,
  },
  {
    name: 'Listar por departamento',
    tag: permissions.KANBAN_TASKS.LIST_BY_DEPARTMENT,
    exclusiveWith: permissions.KANBAN_TASKS.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.KANBAN_TASKS.MANAGE,
  },
  {
    name: 'Finalizar',
    tag: permissions.KANBAN_TASKS.FINALIZE,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.DESTROY,
    tag: permissions.KANBAN_TASKS.DESTROY,
  },
  {
    name: 'Gerenciar Coluna do Kanban',
    tag: permissions.KANBAN_TASKS.MANAGE_COLUMNS,
  },
  {
    name: 'Deletar Coluna do Kanban',
    tag: permissions.KANBAN_TASKS.DESTROY_COLUMN,
  },
  {
    name: 'Deletar Comentários de Outros Usuários',
    tag: permissions.KANBAN_TASKS.DESTROY_COMMENT,
  },
]

export default TASK_LIST
